import React from "react";
import { getAdvantages } from "../../backend/advantage/advantage";
import { Advantage } from "../../types/advantage/advantage";
import { useMediaQuery } from "react-responsive";

const AdvantageCard = ({ advantage }: { advantage: Advantage }) => {
  const isMedium = useMediaQuery({ query: `(max-width: 700px)` });
  const isSmall = useMediaQuery({ query: `(max-width: 450px)` });
  return (
    <div style={{ ...styles.advantageCardContainer, paddingRight: isMedium ? "1rem" : "3rem" }}>
      <div
        style={{
          ...styles.bulletPoint,
          marginTop: isSmall ? "0.5rem" : isMedium ? "0.75rem" : "0.875rem",
        }}
      />
      <div style={styles.infoColumn}>
        <h3
          style={{
            ...styles.advantageName,
            fontSize: isSmall ? "1.5rem" : isMedium ? "2rem" : "2.5rem",
          }}
        >
          {advantage.name}
        </h3>
        <p
          style={{
            ...styles.advantageDescription,
            fontSize: isSmall ? "1rem" : isMedium ? "1.2rem" : "1.25rem",
          }}
        >
          {advantage.description}
        </p>
      </div>
    </div>
  );
};

const Advantages = () => {
  const isSingle = useMediaQuery({ query: `(max-width: 850px)` });
  const isMedium = useMediaQuery({ query: `(max-width: 700px)` });
  const isSmall = useMediaQuery({ query: `(max-width: 450px)` });
  const advantages = getAdvantages();
  return (
    <div style={styles.advantagesWrapper}>
      <div
        style={{
          ...styles.advantagesContainer,
          paddingTop: isSmall ? "2rem" : isSingle ? "3rem" : "4rem",
          paddingBottom: isSmall ? "2rem" : isSingle ? "3rem" : "4rem",
        }}
      >
        <h2
          style={{
            ...styles.header,
            fontSize: isSmall ? "2.5rem" : isSingle ? "3.5rem" : "4rem",
            marginBottom: isSmall ? "1rem" : isSingle ? "2rem" : "3rem",
          }}
        >
          Наші переваги
        </h2>
        <div
          style={{
            ...styles.advantageGrid,
            gap: isSingle ? "1.5rem 0rem" : "3rem 0rem",
            gridTemplateColumns: isSingle ? "1fr" : "1fr 1fr",
          }}
        >
          {advantages.map((advantage) => (
            <AdvantageCard advantage={advantage} />
          ))}
        </div>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  advantagesWrapper: {
    display: "flex",
    width: "100%",
    overflow: "hidden",
    background: "url('assets/texture.avif')",
    backgroundSize: "20%",
  },
  advantagesContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    width: "var(--main-container-width)",
    margin: "0 auto",
    overflow: "hidden",
  },
  header: {
    fontSize: "5rem",
    fontWeight: "bold",
    color: "var(--black)",
  },
  advantageGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
  },
  advantageCardContainer: {
    display: "flex",
    flexDirection: "row",
    gap: "1rem",
    paddingRight: "3rem",
  },
  bulletPoint: {
    width: "15px",
    height: "15px",
    marginTop: "0.85rem",
    backgroundColor: "var(--black)",
    flexShrink: 0,
  },
  infoColumn: {
    display: "flex",
    flexDirection: "column",
  },
  advantageName: {
    fontSize: "2.5rem",
    fontWeight: "bold",
    color: "var(--black)",
    marginBottom: "1rem",
  },
  advantageDescription: {
    fontSize: "1.25rem",
    color: "var(--grey)",
  },
};

export default Advantages;
